export default "__VITE_ASSET__157e40c2__"